<template>
  <v-expansion-panel-content
        ref="contactDetailsStep"
        class="process-step-header"
        :disabled="disabled"
        :aria-disabled="disabled"
  >
    <div slot="header">
      <div class="flex">
        <div class="process-number">{{processNumber}}</div>
        <div class="process-step-name">{{messages.contactDetailsStep}}</div>
      </div>
    </div>
    <v-card>
      <v-card-text class="info-text relative">
        <div tabindex="0">
          <div class="info-text-strong">{{messages.contactDetailsContentChosenText}}</div>
          <div>
            <div v-for="(selectedService, index) in selectedServices" :key="index">
              <div
                v-if="selectedService && selectedService.name"
              >{{servicesTranslations[selectedService.publicId] && servicesTranslations[selectedService.publicId].names[selectedLanguage.lang] ? servicesTranslations[selectedService.publicId].names[selectedLanguage.lang] : selectedService.name}}{{configuration.multiplePeopleEnabled ? ': ' + selectedService.adult + ' ' + messages.chooseServiceContentAdults + ', ' + selectedService.child + ' ' + messages.chooseServiceContentChildren  : ''}}</div>
            </div>
            <div v-if="selectedBranch && selectedBranch.name">{{branchTranslations[selectedBranch.id].names[selectedLanguage.lang] ? branchTranslations[selectedBranch.id].names[selectedLanguage.lang] : selectedBranch.name }}, {{selectedBranch.addressCity}}</div>
            <div>{{selectedDate | formatDate(selectedLanguage)}} {{selectedTimeSlot | formatTime(selectedLanguage)}}</div>
            <div
              v-if="checkShowPricesAndServicePrice"
            >{{messages.totalCost}}: {{totalCost}} {{messages.chooseServiceContentCurrency}}</div>
            <div
              v-if="checkShowPricesAndCondPrice"
            >{{messages.totalCost}}: {{condTotalCost}} {{messages.chooseServiceContentCurrency}}</div>
          </div>
        </div>
        <v-btn
          icon
          :ripple="false"
          :aria-label="messages.ariaResetData"
          color="error"
          class="full-wide-mobile reset-btn"
          @click="$emit('reset-data')"
        >
        {{messages.deleteAppointmentButtonText}}
        </v-btn>
      </v-card-text>
      <v-form ref="form" v-model="valid" v-if="!disabled">
        <div
          class="info-text"
          tabindex="0"
        >{{messages.contactDetailsContentMobileVerificationText}}</div>
        <div
          class="fields-wrapper"
          v-for="(field, index) in configuration.uiFields"
          :key="index"
        >
          <phone-field
            v-if="field.name === 'Phone' && loadMobileVerification"
            @phone-verified="phoneVerified"
            :field="field"
            :read-only="readOnly"
            :email="localContactDetails.Email"
            :show-autocomplete="true"
            :show-appointments="true"
            :services="selectedServices"
            :time="selectedTimeSlot"
            :date="selectedDate"
          ></phone-field>
          <birth-picker
            v-if="field.name === 'DOB'"
            :field="field"
            @birth-selected="birthSelected"
          ></birth-picker>
          <v-text-field
            class="input-field focused-border"
            outline
            height="48"
            v-if="field.name !== 'DOB' && field.name !== 'Phone'"
            :rules="field.m === 1 ? (rules[field.name] ? [rules[field.name], rules.required] : [rules.required]) : (rules[field.name] ? [rules[field.name]] : [])"
            :id="field.name"
            :aria-required="field.m === 1 ? true: false"
            v-model="localContactDetails[field.name]"
          >
            <div slot="label" :for="field.name">{{messages[field.name]}}</div>
          </v-text-field>
        </div>
        <div v-if="configuration.customProperties && configuration.customProperties.enabled">
          <div
            class="fields-wrapper"
            :key="index"
            v-for="(field, index) in customPropertiesListActive"
          >
            <v-select
              v-if="field.parameterType === 'MultipleChoice'"
              class="focused-border custom-field full-wide-select-mobile"
              :id="'custom-field-id-' + index"
              outline
              height="48"
              :items="field.values"
              item-value="value"
              :label="getCustomFieldLabel(index)"
              v-model="customPropertiesSelection[field.parameterName]"
              :hint="getCustomFieldInfo(index)"
              :persistent-hint="isCustomFieldInfoPersistent(index)"
              :aria-label="getCustomFieldLabelAndInfo(index)"
              :rules="field.mandatory ? [rules.required] : []"
            >
              <template v-slot:selection="data">
                {{ getCustomFieldValueLabel(data) }}
              </template>
              <template v-slot:item="data">
                {{ getCustomFieldValueLabel(data) }}
              </template>
            </v-select>
          </div>
        </div>
        <div
          class="notification-type"
          v-if="configuration.showNotificationType && rules.notificationType"
        >
          <small id="notification-group">{{messages.notifyUserByText}}</small>
          <v-radio-group
            v-model="notificationType"
            aria-labelledby="notification-group"
            row
            :rules="[rules.notificationType]"
          >
            <v-radio :ripple="false" aria-labelledby="sms-notification" mandatory value="sms">
              <div slot="label" id="sms-notification">{{messages.Phone}}</div>
            </v-radio>
            <v-radio
              :ripple="false"
              aria-labelledby="email-notification"
              mandatory
              value="email"
            >
              <div slot="label" id="email-notification">{{messages.Email}}</div>
            </v-radio>
          </v-radio-group>
        </div>
        <!--div>{{ configuration.customProperties }}</div-->
        <appointment-list
          v-if="loadAppointmentList"
          :existing-appointments="existingAppointments"
          :phone="localContactDetails.formattedPhone"
          :email="localContactDetails.Email"
          :time="selectedTimeSlot"
          :date="selectedDate"
          :services="selectedServices"
          :status="restrictStatus"
          @appointment-deleted="appointmentDeleted"
        ></appointment-list>
        <v-checkbox
          :ripple="false"
          aria-labelledby="agreement"
          class="info-text agreement"
          v-model="agreement"
          required
          :rules="[rules.agreement]"
        >
          <div slot="label"><span v-html="messages.agreementHtml1" @click.stop.prevent="showModalDialog1"></span>&nbsp;<span v-html="messages.agreementHtml2" @click.stop.prevent="showModalDialog2"></span></div>
        </v-checkbox>
        <modal-dialog
          :dialog="dialog"
          :dialogMessage="dialogMessage"
          :dialogTitle="dialogTitle"
          :dialogButtonText="dialogButtonText"
          @closemodal="dialog = false">
        </modal-dialog>
        <v-btn
          :ripple="false"
          flat
          class="submit"
          @click="onSubmit"
          :disabled="status==='submitting' || (!phoneIsVerified && configuration.sendConfirm)|| tooManyAppointments || !agreement"
          id='contactStepCreateAppointmentButton'
        >
          <div v-if="status === ''">{{messages.createAppointmentButtonText}}</div>
          <v-progress-circular role="progressbar" indeterminate class="progress-bar" v-else></v-progress-circular>
        </v-btn>
        <v-alert role="alert" :value="confirmError" type="error">{{confirmErrorMessage}}</v-alert>
        <vue-recaptcha
          v-if="phoneIsVerified && !tooManyAppointments && configuration.captchaEnabled"
          ref="recaptcha"
          @verify="onCaptchaVerified"
          @expired="onCaptchaExpired"
          size="invisible"
          badge="inline"
          :sitekey="configuration.captchaSiteKey"
        ></vue-recaptcha>
      </v-form>
    </v-card>
  </v-expansion-panel-content>
</template>
<script>
import RestService from '../services/restService'
import DataService from '../services/dataService'
import { mapActions, mapState, mapGetters } from 'vuex'
import PhoneField from '../components/PhoneField'
import AppointmentList from '../components/AppointmentList'
import ModalDialog from '../components/Modal'
import VueRecaptcha from 'vue-recaptcha'
import { eventHub } from '../utils/eventhub'
import BirthPicker from '../components/BirthPicker'

export default {
  name: 'ContactStep',
  props: [
    'disabled',
    'processNumber',
    'loadMobileVerification',
    'loadAppointmentList',
    'startPage',
    'urlParams'
  ],
  mixins: [RestService, DataService],
  components: {
    PhoneField,
    AppointmentList,
    VueRecaptcha,
    ModalDialog,
    BirthPicker
  },
  data: () => ({
    valid: false,
    localContactDetails: {
      formattedPhone: '',
      Phone: '',
      Email: '',
      countryCode: '',
      LastName: '',
      FirstName: '',
      DOB: '',
      ConfirmEmail: '',
      ConfirmPhone: '',
      CustRef: '',
      Notes: ''
    },
    customPropertiesSelection: {},
    rules: {
      Email: false,
      ConfirmEmail: false,
      ConfirmPhone: false,
      agreement: false,
      notificationType: false,
      required: false
    },
    notificationType: '',
    readOnly: false,
    existingAppointments: [],
    restrictStatus: null,
    agreement: false,
    dialog: false,
    dialogMessage: '',
    dialogTitle: '',
    dialogButtonText: '',
    phoneIsVerified: false,
    tooManyAppointments: false,
    status: '',
    confirmError: false,
    confirmErrorMessage: null,
    recaptchaToken: '', // what is the use of this, why store it ?
    regexEmail: '' // ,
    // appointmentIsCancelled: false //no use for this, remove ?
  }),
  computed: {
    ...mapState([
      'configuration',
      'selectedServices',
      'selectedBranch',
      'servicesTranslations',
      'branchTranslations',
      'selectedDate',
      'selectedTimeSlot',
      'contactDetails', // check
      'reservedAppointmedId',
      'messages',
      'selectedLanguage',
      'funcDebug',
      'condTotalCost'
    ]),
    ...mapGetters({
      totalCost: 'selectedServicesTotalCost',
      customSlotLength: 'customSlotLength'
    }),
    customPropertiesListActive () {
      if (this.configuration.customProperties.customPropertiesList) {
        return this.configuration.customProperties.customPropertiesList.filter((element) => element.active === true)
      } else {
        return []
      }
    },
    checkShowPricesAndCondPrice () {
      return this.configuration.pricesEnabled && this.configuration.showPrices && this.configuration.priceCalc === 'conditionalPrice'
    },
    checkShowPricesAndServicePrice () {
      return this.configuration.pricesEnabled && this.configuration.showPrices && this.configuration.priceCalc === 'servicesPrice'
    },
    checkCondPrice () {
      return this.configuration.pricesEnabled && this.configuration.priceCalc === 'conditionalPrice'
    }
  },
  watch: {
    selectedLanguage () {
      if (this.$refs && this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    }
  },
  methods: {
    ...mapActions([
      'setContactDetails',
      'setCustomFields'
    ]),
    getCustomFieldLabel (index) {
      return this.customPropertiesListActive[index].labels[this.selectedLanguage.lang]
    },
    getCustomFieldInfo (index) {
      return this.customPropertiesListActive[index].infos[this.selectedLanguage.lang]
    },
    isCustomFieldInfoPersistent (index) {
      if (this.customPropertiesListActive[index].infos[this.selectedLanguage.lang].length > 0) {
        return true
      } else {
        return false
      }
    },
    getCustomFieldValueLabel (data) {
      let labels = data.item.labels
      return labels[this.selectedLanguage.lang]
    },
    getCustomFieldLabelAndInfo (index) {
      return this.customPropertiesListActive[index].labels[this.selectedLanguage.lang] + ' - ' +
        this.customPropertiesListActive[index].infos[this.selectedLanguage.lang]
    },
    // callbacks
    phoneVerified (verified, formattedPhone, phone, status, readOnly) {
      if (this.funcDebug) console.log('ContactStep:methods:phoneVerified')
      this.localContactDetails.Phone = phone
      var _this = this
      if (verified && this.configuration.sendConfirm) {
        this.phoneIsVerified = verified
        this.restrictStatus = status
        if (status.message.startsWith('ERROR_MULTI')) {
          if (status.message.includes('SAMEDAY')) { _this.restrictStatus.message = 'ERROR_MULTI_RESTRICT_SAMEDAY' } else { _this.restrictStatus.message = 'ERROR_MULTI_RESTRICT' }
          this.status = ''
          this.tooManyAppointments = true
          _this.$emit('update:loadAppointmentList', true)
        } else if (status.message !== 'MULTIPLE_OK') {
          this.tooManyAppointments = true
        }
        this.localContactDetails.formattedPhone = formattedPhone
        this.readOnly = readOnly
        this.findAppointment(this.localContactDetails).then(response => {
          if (this.funcDebug) console.log('ContactStep:methods:phoneVerified:findAppointment.then')
          _this.existingAppointments = response.data
          if (_this.existingAppointments.length > 0) {
            if (_this.existingAppointments[0].errorMessage === 'ERROR_CUSTOMERS_MULTIPLE') {
              if (_this.tooManyAppointments) { _this.restrictStatus.message = 'ERROR_CUSTOMERS_MULTIPLE' } else { _this.restrictStatus.message = 'INFO_CUSTOMERS_MULTIPLE' }
              _this.existingAppointments = []
            } else if (_this.existingAppointments[0].errorMessage === 'ERROR_SESSION_VIOLATION') {
              _this.restrictStatus.message = 'ERROR_SESSION_VALIDATION'
              _this.existingAppointments = []
            } else if (_this.existingAppointments[0].errorMessage === 'ERROR_NOT_ENOUGH_SEARCH_FIELDS') {
              _this.restrictStatus.message = 'ERROR_NOT_ENOUGH_SEARCH_FIELDS'
              _this.existingAppointments = []
            }
            _this.$emit('update:loadAppointmentList', true)
          }
        })
      } else {
        this.phoneIsVerified = verified
        this.localContactDetails.formattedPhone = formattedPhone
      }
    },
    birthSelected (birth) {
      this.localContactDetails.DOB = birth
    },
    appointmentDeleted (deleted) {
      if (deleted) {
        // this.appointmentIsCancelled = deleted => not used
        this.tooManyAppointments = false
      }
    },
    onCaptchaVerified (recaptchaToken) {
      if (this.funcDebug) console.log('ContactStep:methods:onCaptchaVerified')
      this.recaptchaToken = recaptchaToken
      if (!this.configuration.sendConfirm) {
        this.checkRestrictStatus(recaptchaToken)
      } else {
        this.confirmReserved(recaptchaToken)
      }
    },
    onCaptchaExpired () {
      if (this.funcDebug) console.log('ContactStep:methods:onCaptchaExpired')
      this.$refs.recaptcha.reset()
    },
    showModalDialog1 () {
      if (this.messages.agreementHtml1.indexOf('<a') >= 0) {
        this.dialogMessage = this.messages.dialog1Text
        this.dialogTitle = this.messages.dialog1Title
        this.dialogButtonText = this.messages.dialog1ButtonText
        this.dialog = true
      }
    },
    showModalDialog2 () {
      if (this.messages.agreementHtml2.indexOf('<a') >= 0) {
        this.dialogMessage = this.messages.dialog2Text
        this.dialogTitle = this.messages.dialog2Title
        this.dialogButtonText = this.messages.dialog2ButtonText
        this.dialog = true
      }
    },
    onSubmit () {
      if (this.funcDebug) console.log('ContactStep:methods:onSubmit')
      if (this.$refs.form.validate()) {
        this.status = 'submitting'
        if (this.configuration.captchaEnabled) {
          this.$refs.recaptcha.execute()
        } else {
          if (!this.configuration.sendConfirm) {
            this.checkRestrictStatus(false)
          } else {
            this.confirmReserved(false)
          }
        }
      }
    },
    // internal functions
    checkRestrictStatus (token) {
      if (this.funcDebug) console.log('ContactStep:methods:checkRestrictStatus')
      var _this = this
      this.checkRestrictions(this.localContactDetails.formattedPhone,
        this.localContactDetails.Email,
        this.selectedServices,
        this.selectedDate,
        this.selectedTimeSlot).then(response => {
        if (this.funcDebug) console.log('ContactStep:methods:checkRestrictStatus:checkRestrictions.then')
        this.restrictStatus = response.data

        if (response.data.message !== 'MULTIPLE_OK') {
          if (response.data.message.startsWith('ERROR_MULTI')) {
            if (response.data.message.includes('SAMEDAY')) { _this.restrictStatus.message = 'ERROR_MULTI_RESTRICT_SAMEDAY' } else { _this.restrictStatus.message = 'ERROR_MULTI_RESTRICT' }
          }
          _this.tooManyAppointments = true
          _this.status = ''
          _this.findAppointment(_this.localContactDetails).then(response => {
            if (this.funcDebug) console.log('ContactStep:methods:checkRestrictStatus:findAppointment.then')
            _this.existingAppointments = response.data
            if (_this.restrictStatus.message.startsWith('ERROR_MULTI') && _this.existingAppointments.length === 0) {
              // A violation to multiple appointments restrictions has been detected. But the returned appointment list is empty
              // That means that the restriction was violated by someone with the same email/phone but is not
              // exactly the same customer. In this case just show the correct error message, but do not show any appointments
              _this.existingAppointments = []
              _this.$emit('update:loadAppointmentList', true)
            }
            if (_this.existingAppointments.length > 0) {
              if (_this.existingAppointments[0].errorMessage === 'ERROR_CUSTOMERS_MULTIPLE') {
                if (_this.tooManyAppointments) { _this.restrictStatus.message = 'ERROR_CUSTOMERS_MULTIPLE' } else { _this.restrictStatus.message = 'INFO_CUSTOMERS_MULTIPLE' }
                _this.existingAppointments = []
              } else if (_this.existingAppointments[0].errorMessage === 'ERROR_SESSION_VIOLATION') {
                _this.restrictStatus.message = 'ERROR_SESSION_VALIDATION'
                _this.existingAppointments = []
              } else if (_this.existingAppointments[0].errorMessage === 'ERROR_NOT_ENOUGH_SEARCH_FIELDS') {
                _this.restrictStatus.message = 'ERROR_NOT_ENOUGH_SEARCH_FIELDS'
                _this.existingAppointments = []
              }
              _this.$emit('update:loadAppointmentList', true)
            }
          })
        } else {
          _this.confirmReserved(false)
        }
      })
    },
    confirmReserved (token) {
      if (this.funcDebug) console.log('ContactStep:methods:confirmReserved')
      var _this = this
      let totalCostToSave = 0
      if (this.configuration.pricesEnabled) {
        totalCostToSave = this.checkCondPrice ? this.condTotalCost : this.totalCost
      }
      this.confirmAppointment(
        this.selectedServices,
        this.reservedAppointmedId,
        this.localContactDetails,
        this.selectedLanguage.lang,
        token,
        totalCostToSave,
        this.customSlotLength,
        this.notificationType,
        this.customPropertiesSelection
      ).then(response => {
        if (this.funcDebug) console.log('ContactStep:methods:confirmReserved:confirmAppointment.then')
        switch (response.data.errorMessage) {
          case 'ERROR_TOO_MANY_RESCHEDULES':
            _this.confirmError = true
            _this.status = ''
            _this.confirmErrorMessage = _this.messages.tooManyReschedules
            break
          case 'ERROR_EXPIRED':
            _this.confirmError = true
            _this.status = ''
            _this.confirmErrorMessage = _this.messages.errorReservedExpired
            break
          case 'ERROR_SESSION_VIOLATION':
            _this.confirmError = true
            _this.status = ''
            _this.confirmErrorMessage = _this.messages.errorSessionViolation
            break
          case 'ERROR_GENERIC':
            _this.confirmError = true
            _this.status = ''
            _this.confirmErrorMessage = _this.messages.errorGenericConfirm
            break
          default:
            // save contactDetails in the store
            _this.setContactDetails(_this.localContactDetails)
            _this.setCustomFields(_this.customPropertiesSelection)
            _this.$router.push({
              name: 'confirmation',
              params: {
                confirmation: response.data,
                startPage: _this.startPage,
                urlParams: _this.urlParams
              }
            })
            break
        }
      })
    },
    setfocus () {
      var _this = this
      this.$nextTick(() => {
        _this.$refs.contactDetailsStep.$el.focus()
      })
    }
  },
  mounted () {
    if (this.funcDebug) console.log('ContactStep:mounted')
    var _this = this
    this.regexEmail = new RegExp(this.configuration.regexEmail)
    // Initiate validation rules
    this.rules.required = v => !!v || _this.messages.fieldRequired === undefined ? false : _this.messages.fieldRequired
    this.rules.Email =
      v => {
        if (v && v.length > 0) {
          return _this.regexEmail.test(v) || _this.messages.invalidEmail === undefined ? false : _this.messages.invalidEmail
        } else {
          return true
        }
      }
    this.rules.ConfirmPhone =
      v => {
        if (v && v.length > 0 && _this.localContactDetails.Phone.length > 0) {
          return v === _this.localContactDetails.Phone || _this.messages.confirmPhoneError === undefined ? false : _this.messages.confirmPhoneError
        } else {
          return true
        }
      }
    this.rules.ConfirmEmail =
      v => {
        if (v && v.length > 0 && _this.localContactDetails.Email.length > 0) {
          return v === _this.localContactDetails.Email || _this.messages.confirmEmailError === undefined ? false : _this.messages.confirmEmailError
        } else {
          return true
        }
      }
    this.rules.agreement = v => !!v || this.messages.agreementRequired === undefined ? false : _this.messages.agreementRequired
    this.rules.notificationType = v => !!v || this.messages.notifyUserError === undefined ? false : _this.messages.notifyUserError
    eventHub.$on('contact-step-focus', this.setfocus)
  }
}
</script>

<style scoped lang="scss">

.custom-field {
  width: 550px;
  margin: 0 0 0 24px;
}

@media only screen and (max-width: 599px) {
  .full-wide-mobile {
    width:100% !important;
    position: relative !important;
  }
  .full-wide-select-mobile {
    padding: 0 16px !important;
    width: 100% !important;
    margin: 0 !important;
  }
}

</style>
